import { useEffect } from 'react'

import { getAuth } from '@firebase/auth'
import { useQueryClient } from '@tanstack/react-query'
import { onAuthStateChanged } from 'firebase/auth'

import { userStore } from '@/features/user/user.store'

import { userQueryKeys } from '../hooks'

import type { User } from 'firebase/auth'

let isSubscribed = false

export const useAuthSync = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    // Ensure only one subscription exists globally
    if (isSubscribed) return

    isSubscribed = true
    const auth = getAuth()

    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      // Directly update the cache without refetching
      queryClient.setQueryData<User | null>(
        userQueryKeys.authData.queryKey,
        firebaseUser,
      )

      // Cleared on sign-out too, or the previous user's private columns would
      // still count as "mine" until a reload.
      userStore.userId = firebaseUser?.uid ?? ''
    })

    return () => {
      isSubscribed = false
      unsubscribe()
    }
  }, [queryClient])
}
